export default __webpack_public_path__ + "static/media/lock-g.1a11e2d6.svg";